module.exports = __webpack_public_path__ + "img/ic-arrow-right-white-alt.6cf31c85.svg";